import { CollegeListResponse } from "infrastructure/services/types/college.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = [] as CollegeListResponse;

export const collegeListReducer = createSlice({
  name: "CollegeListReducer",
  initialState,
  reducers: {
    saveCollegeList: (state, action: PayloadAction<CollegeListResponse>) => {
      return action.payload;
    },
    resetCollegeList: () => {
      return initialState;
    },
  },
});

export const { resetCollegeList, saveCollegeList } = collegeListReducer.actions;

export const getCollegeListRedux = (state: RootState) => { return state.collegeListReducer };

export default collegeListReducer.reducer;
